    (function () {
        'use strict';

        angular
            .module('gov.directives')
            .directive('govNaEmpty', directive);

        directive.$inject = [];

        function directive() {
            return {
                restrict: 'A',
                priority: 10, // Run after ng-bind and textarea-read
                link: function (scope, element, attr) {
                    var attrName;
                    if (attr.hasOwnProperty('ngBind')) {
                        attrName = 'ngBind';
                    } else if (attr.hasOwnProperty('model')) {
                        attrName = 'model';
                    } else {
                        // No supported attribute to generate content
                        return;
                    }

                    var isOneTimeBound = false;
                    var scopePath = attr[attrName];

                    if (scopePath.substr(0, 2) === '::') {
                        isOneTimeBound = true;
                        scopePath = scopePath.substr(2);
                    }
                    var unwatch = scope.$watch(scopePath, function (newVal) {

                        if (_.isNil(newVal)
                            || (_.isArray(newVal) && newVal.length === 0)
                            || (_.isObject(newVal) && _.isEmpty(newVal))) {

                            newVal = 'n/a';
                            element.addClass('is-empty');
                        }
                        element.prop('innerText', newVal);

                        if (isOneTimeBound) {
                            unwatch();
                        }
                    })
                }
            }
        }
    })();